import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { handleAPI } from '../../../utils/api/api';

const initialState = {
  orders: [],
  order: {},
  totalPages: null,
  totalCount: null,
  count: null,
  isLoading: true,
  error: null,
};

export const getOrders = createAsyncThunk('orders/getOrders', (params) => {
  return handleAPI('platform/orders', 'get', params);
});

export const getOrder = createAsyncThunk('orders/getOrder', ({ number, params }) => {
  return handleAPI(`platform/orders/${number}`, 'get', params);
});

const orderSlice = createSlice({
  name: 'order',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getOrders.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getOrders.fulfilled, (state, action) => {
      state.isLoading = false;
      state.orders = action.payload;
      state.totalPages = action?.metaData?.total_pages;
      state.totalCount = action?.metaData?.total_count;
      state.count = action?.metaData?.count;
    });
    builder.addCase(getOrders.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
    builder.addCase(getOrder.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getOrder.fulfilled, (state, action) => {
      state.isLoading = false;
      state.order = action.payload;
    });
  },
});

export default orderSlice.reducer;
